window.SMTX.FormModule = (function () {

  if ($('[data-form-module]').length < 1) {
    return false;
  }

  // Find the corresponding Form
  var form = $('[data-form-module]').find('form')[0];
  var formHandle = $('[data-form-module]').attr('data-form-module');
  log(formHandle);
    
  $.ajax({
    // Specify the form handle in the GET parameters
    url: '/form-cache-bust?form=' + formHandle,
    type: 'get',
    dataType: 'json',
    success: function (response) {
      // Update the Form Hash
      form.querySelector('input[name=formHash]').value = response.hash;

      // Locate and update the CSRF input
      var csrf = response.csrf;
      form.querySelector('input[name=' + csrf.name + ']').value = csrf.value;
    },
  });


  form.addEventListener("freeform-ready", function (event) {
    // Enable AJAX. This happens automatically if you enable AJAX via the form composer
    freeform = event.target.freeform;
    
    var topMenu = document.querySelector('header .top-menu');
    
    event.options.scrollOffset = -topMenu.offsetHeight;
    
    var successMsg = $('[data-form-module] [data-form-success-msg]').text();
    if($.trim(successMsg) == ""){
      successMsg = "Thank you! The form was successfully submitted.";
    }

    freeform.setOption('ajax', true);
    freeform.setOption("successBannerMessage", successMsg);
  });
  
  return {

  };
    
})();
